import React from 'react';
import { ResponsiveLine } from '@nivo/line';

import { line } from 'd3-shape';
import style from './result-chart.module.scss';
import { demoData } from './demoData.js';

const ResultChart = ({ data, range, title, noData }) => {
  const BulletLine = ({ series, xScale, yScale, innerHeight }) => {
    return (
      <>
        {series[0].data.map((entry, index) => {
          const lineGenerator = line()([
            [entry.position.x, entry.position.y],
            [entry.position.x, innerHeight]
          ]);
          return (
            <path
              key={`path-${index}`}
              d={lineGenerator}
              fillOpacity={0}
              stroke="#db0a40"
              strokeWidth={2}
            />
          );
        })}
      </>
    );
  };

  return (
    <div className="appRow full-width" style={{ position: 'relative' }}>
      {title && <h3 className={`h3 ${style.title}`}>{title}</h3>}
      <div
        style={{
          height: 142,
          width: '100%',
          backgroundColor: 'rgba(248, 248, 248, 0.08)',
          padding: '5px 12px',
          borderTop: '1px solid rgba(248,248,248,0.3)',
          borderBottom: '1px solid rgba(248,248,248,0.3)'
        }}
        className={`${style.resultChart}${data ? '' : ` ${style.noData}`}`}
      >
        <ResponsiveLine
          isInteractive={false}
          data={data ? [data] : [demoData(range)]}
          margin={{ top: 32, right: 24, bottom: 32, left: 24 }}
          xScale={{ type: 'point' }}
          yScale={{
            type: 'linear',
            min: 0,
            max: range - 1,
            stacked: false,
            reverse: false
          }}
          curve={'linear'}
          axisTop={null}
          axisRight={null}
          axisLeft={null}
          // axisBottom={{
          //   orient: 'bottom',
          //   tickSize: 5,
          //   tickPadding: 5,
          //   tickRotation: 0,
          //   legendOffset: 0,
          //   legendPosition: 'middle'
          // }}
          colors={'#fff'}
          lineWidth={0}
          pointSize={4}
          pointColor={{ from: 'color', modifiers: [] }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'color', modifiers: [] }}
          enablePointLabel={true}
          pointLabel={(data) => {
            return data.entryType;
          }}
          axisBottom={{
            format: (data) => {
              return data.replace(/-->[0-9]+<--/, '');
            }
          }}
          pointLabelYOffset={-12}
          pointLabelXOffset={-12}
          enableArea={true}
          areaOpacityn={0.1}
          useMesh={true}
          enableCrosshair={false}
          enableGridX={false}
          enableGridY={false}
          theme={{
            textColor: '#fff',
            axis: {
              fontSize: '14px',
              ticks: {
                line: {
                  stroke: 'transparent'
                },
                text: {
                  fill: '#ffffff'
                }
              }
            }
          }}
          layers={[
            'grid',
            'markers',
            'areas',
            BulletLine,
            'lines',
            'slices',
            'axes',
            'points',
            'legends'
          ]}
        />
      </div>
      {!data && <div className={style.resultInfo}>{noData}</div>}
    </div>
  );
};
export { ResultChart };
